var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:{'is--loading': _vm.isLoading},attrs:{"id":"fillit-map-container","data-active":_vm.slug}})])
}
var staticRenderFns = []

export { render, staticRenderFns }